import { HandleReturnItemChange } from 'components/Orders/Order';
import Flex from 'components/ui/Flex';
import Input from 'components/ui/Input';
import { CellInputRefs } from 'hooks/useKeyboardNavigation';
import { ReturnOrderLine } from 'returnCenter-api';
import { ExtendedReturnItem } from 'store/reducers/returnSlice';
import styled from 'styled-components';

type LpnCellProps = {
    item?: ExtendedReturnItem;
    itemId?: number | string;
    orderline?: ReturnOrderLine;
    handleReturnItemChange?: HandleReturnItemChange;
    disabled?: boolean;
    rowIndex?: number;
    colIndex?: number;
    cellInputRefs?: CellInputRefs;
    handleArrowKeyDown?: (e: React.KeyboardEvent, itemId: string | number, rowIndex: number, colIndex: number) => void;
    cellRefPrefix?: string;
};

const LpnCell = ({
    item,
    itemId,
    orderline,
    handleReturnItemChange,
    disabled,
    rowIndex,
    colIndex,
    cellInputRefs,
    handleArrowKeyDown,
    cellRefPrefix = '',
}: LpnCellProps) => {
    return (
        <Flex column>
            <StyledInput
                data-allow-paste
                disabled={disabled}
                data-input
                data-row={rowIndex}
                data-row-cell={colIndex}
                data-item-id={itemId}
                key={itemId}
                ref={(el) => {
                    if (cellInputRefs && rowIndex !== undefined && colIndex !== undefined) {
                        const refKey = `${cellRefPrefix}${rowIndex}-${colIndex}`;
                        cellInputRefs.current[refKey] = el;
                    }
                }}
                onChange={(event) => {
                    const value = event.currentTarget.value;
                    handleReturnItemChange?.(
                        orderline?.orderNumber ?? '',
                        orderline?.sku ?? '',
                        orderline?.orderLineNumber ?? '',
                        itemId ?? -1,
                        'lpn',
                        value,
                    );
                }}
                onKeyDown={(e) => {
                    if (handleArrowKeyDown && rowIndex !== undefined && colIndex !== undefined) {
                        handleArrowKeyDown(e, itemId ?? -1, rowIndex, colIndex);
                    }
                }}
                value={item?.lpn ?? ''}
            />
        </Flex>
    );
};

export default LpnCell;

const StyledInput = styled(Input)`
    width: 100%;
    flex: 1;
    input {
        border-radius: 4px;
        height: 38px !important;
        padding-left: 10px !important;
    }

    > * {
        font-size: 11px !important;
    }
`;
